var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[(_vm.uploadLink)?_c('v-img',{attrs:{"src":_vm.uploadLink,"max-height":"700","contain":""}}):_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"width":"700","type":"image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }